<template>

    <div>

        <div class="flex items-center font-medium gap-x-2 text-sm">
            Automatic data deletion
            <UpgradePlan v-if="!canChangeFeature" />
        </div>

        <div class="flex mt-5 text-sm">
            <div class="flex flex-row flex-grow">
                <div class="flex flex-grow items-center gap-x-2" v-if="!is_enabled_inbound || !canChangeFeature"
                    :class="{ 'text-gray-400': !canChangeFeature }">
                    <InboxArrowDownIcon class="size-4" /> Permanently delete
                    <span class="font-bold mx-1">Incoming</span> recordings after a defined period
                </div>
                <div class="flex flex-grow" v-else>
                    <div class="flex  items-center gap-x-2">
                        <InboxArrowDownIcon class="size-4" />
                        Permanently delete <span class="font-bold text-sm mx-1">Incoming</span> recordings after
                    </div>
                    <div class="flex mx-4">

                        <input type="text" :value="autodelete_incoming_form" @input="changedInput('incoming', $event)"
                            :size="incoming_size"
                            class="text-center inline py-0 mt-0 px-0.5 border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-blue-500 font-bold focus:bg-blue-50 text-sm" />
                    </div>
                    <div class="flex mr-1">
                        <span v-if="autodelete_incoming_form > 1">days</span>
                        <span v-else>day</span>
                    </div>
                    <div class="flex mr-1">
                        <jet-dropdown align="left" width="36" class="flex" style="margin-top:-1px">
                            <template #trigger>
                                <span class="inline-flex rounded-md">
                                    <button type="button"
                                        class="inline-flex items-center px-2 py-0 border border-transparent focus:outline-none"
                                        :class="tag_alert_incoming ? 'text-red-500 hover:text-red-700' : incoming_tag_name_exception == '' ? 'text-gray-500 hover:text-gray-700' : 'text-black hover:text-gray-700'"
                                        v-tippy="{ content: tag_alert_incoming ? 'Warning: this tag does not exist anymore, no exception will apply' : null }">

                                        <span v-if="tag_alert_incoming" class="">
                                            except <span
                                                class="px-1 py-0.5 text-sm border border-gray-200 bg-gray-100 rounded font-bold"
                                                :class="tag_alert_incoming ? 'text-red-500' : 'text-blue-700'">{{
                                                    incoming_tag_name_exception }}</span> tag
                                        </span>
                                        <span v-else-if="incoming_tag_name_exception == ''" class="">
                                            with no tag exception
                                        </span>
                                        <span v-else class="">
                                            except <span class="px-2 py-1 border-0 rounded text-gray-700 text-xs"
                                                :style="'background-color:' + get_tag(incoming_tag_slug_exception).color">{{
                                                    incoming_tag_name_exception }}</span> tag
                                        </span>

                                        <svg v-if="tag_alert_incoming" class="ml-2 -mr-0.5 h-4 w-4"
                                            xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <path
                                                d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z">
                                            </path>
                                            <line x1="12" y1="9" x2="12" y2="13"></line>
                                            <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                        </svg>
                                        <svg v-else class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </button>
                                </span>
                            </template>

                            <template #content>
                                <a href="#"
                                    class="px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                    :class="{ 'text-blue-500 font-bold': incoming_tag_slug_exception == '' }"
                                    @click.prevent="changeException('incoming', null)">
                                    <span class="flex flex-grow">No tag exception</span>
                                    <vue-feather v-if="incoming_tag_slug_exception == ''" type="check"
                                        class="w-4 h-4 ml-2 self-center"></vue-feather>
                                </a>
                                <a href="#" v-for="tag in tags" :key="'tag_' + tag.id"
                                    class="px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                    :class="{ 'text-blue-500 font-bold': tag.slug == incoming_tag_slug_exception }"
                                    @click.prevent="changeException('incoming', tag)">
                                    <span class="flex flex-grow">{{ tag.name }}</span>
                                    <vue-feather v-if="tag.slug == incoming_tag_slug_exception" type="check"
                                        class="w-4 h-4 ml-2 self-center"></vue-feather>
                                </a>
                            </template>
                        </jet-dropdown>
                    </div>
                </div>
                <div class="flex items-center">
                    <toggle :checked="is_enabled_inbound && canChangeFeature" :disabled="!canChangeFeature"
                        @click.prevent.stop @update="toggleInbound"></toggle>

                    <toggle v-if="false" :checked="is_enabled_inbound" @click.prevent.stop @update="toggleInbound">
                    </toggle>
                    <span v-if="false" class="text-sm text-gray-400">Only available for
                        <inertia-link v-if="$page.props.canManagePlan" :href="route('subscription.index')"
                            class="text-blue-500 hover:underline">Enterprise plan customers</inertia-link>
                        <span v-else class="text-gray-600 cursor-pointer"
                            v-tippy="{ content: 'Ask an administrator for upgrading' }"
                            @click="showUpgradeModal">Enterprise plan customers</span>
                    </span>
                </div>
            </div>
        </div>

        <div class="flex mt-5 text-sm">
            <div class="flex flex-row flex-grow">
                <div class="flex flex-grow items-center gap-x-2" v-if="!is_enabled_outbound || !canChangeFeature"
                    :class="{ 'text-gray-400': !canChangeFeature }">
                    <UserGroupIcon class="size-4" /> Permanently
                    delete <span class="font-bold mx-1">Team</span> recordings after a defined period
                </div>
                <div class="flex flex-grow" v-else>
                    <div class="flex items-center gap-x-2">
                        <UserGroupIcon class="size-4" />
                        Permanently delete <span class="font-bold text-sm mx-1">Team</span> recordings after
                    </div>
                    <div class="flex mx-4">
                        <input type="text" :value="autodelete_outgoing_form" @input="changedInput('outgoing', $event)"
                            :size="outgoing_size"
                            class="text-center inline py-0 mt-0 px-0.5 border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-blue-500 font-bold focus:bg-blue-50 text-sm" />
                    </div>
                    <div class="flex mr-1">
                        <span v-if="autodelete_outgoing_form > 1">days</span>
                        <span v-else>day</span>
                    </div>
                    <div class="flex mr-1">
                        <jet-dropdown align="left" width="36" class="flex" style="margin-top:-1px">
                            <template #trigger>
                                <span class="inline-flex rounded-md">
                                    <button type="button"
                                        class="inline-flex items-center px-2 py-0 border border-transparent focus:outline-none"
                                        :class="tag_alert_outgoing ? 'text-red-500 hover:text-red-700' : outgoing_tag_name_exception == '' ? 'text-gray-500 hover:text-gray-700' : 'text-black hover:text-gray-700'"
                                        v-tippy="{ content: tag_alert_outgoing ? 'Warning: this tag does not exist anymore, no exception will apply' : null }">

                                        <span v-if="tag_alert_outgoing" class="">
                                            except <span
                                                class="px-1 py-0.5 text-xs border border-gray-200 bg-gray-100 rounded font-bold"
                                                :class="tag_alert_outgoing ? 'text-red-500' : 'text-blue-700'">{{
                                                    outgoing_tag_name_exception }}</span> tag
                                        </span>
                                        <span v-else-if="outgoing_tag_name_exception == ''" class="">
                                            with no tag exception
                                        </span>
                                        <span v-else class="">
                                            except <span class="px-2 py-1 rounded text-gray-700 text-xs"
                                                :style="'background-color:' + get_tag(outgoing_tag_slug_exception).color">{{
                                                    outgoing_tag_name_exception }}</span> tag
                                        </span>

                                        <svg v-if="tag_alert_outgoing" class="ml-2 -mr-0.5 h-4 w-4"
                                            xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <path
                                                d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z">
                                            </path>
                                            <line x1="12" y1="9" x2="12" y2="13"></line>
                                            <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                        </svg>
                                        <svg v-else class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </button>
                                </span>
                            </template>

                            <template #content>
                                <a href="#"
                                    class="px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                    :class="{ 'text-blue-500 font-bold': outgoing_tag_slug_exception == '' }"
                                    @click.prevent="changeException('outgoing', null)">
                                    <span class="flex flex-grow">No tag exception</span>
                                    <vue-feather v-if="outgoing_tag_slug_exception == ''" type="check"
                                        class="w-4 h-4 ml-2 self-center"></vue-feather>
                                </a>
                                <a href="#" v-for="tag in tags" :key="'tag_' + tag.id"
                                    class="px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                    :class="{ 'text-blue-500 font-bold': tag.slug == outgoing_tag_slug_exception }"
                                    @click.prevent="changeException('outgoing', tag)">
                                    <span class="flex flex-grow">{{ tag.name }}</span>
                                    <vue-feather v-if="tag.slug == outgoing_tag_slug_exception" type="check"
                                        class="w-4 h-4 ml-2 self-center"></vue-feather>
                                </a>
                            </template>
                        </jet-dropdown>
                    </div>
                </div>
                <div class="flex items-center">
                    <toggle :checked="is_enabled_outbound && canChangeFeature" :disabled="!canChangeFeature"
                        @click.prevent.stop @update="toggleOutbound"></toggle>

                    <toggle v-if="false" :checked="is_enabled_outbound" @click.prevent.stop @update="toggleOutbound">
                    </toggle>
                    <span v-if="false" @click="showUpgradeModal" class="text-sm text-gray-400">Only available for
                        <inertia-link v-if="$page.props.canManagePlan" :href="route('subscription.index')"
                            class="text-blue-500 hover:underline">Enterprise plan customers</inertia-link>
                        <span v-else class="text-gray-600 cursor-pointer"
                            v-tippy="{ content: 'Ask an administrator for upgrading' }"
                            @click="showUpgradeModal">Enterprise
                            plan
                            customers</span>
                    </span>
                </div>
            </div>
        </div>



        <div class="flex mt-5 text-sm">
            <div class="flex flex-row flex-grow">
                <div class="flex flex-grow items-center gap-x-2" v-if="!is_enabled_personal || !canChangeFeature"
                    :class="{ 'text-gray-400': !canChangeFeature }">
                    <UserIcon class="size-4" /> Permanently
                    delete <span class="font-bold mx-1">Personal</span> recordings after a defined period
                </div>
                <div class="flex flex-grow" v-else>
                    <div class="flex items-center gap-x-2">
                        <UserIcon class="size-4" />
                        Permanently delete <span class="font-bold text-sm mx-1">Personal</span> recordings after
                    </div>
                    <div class="flex mx-4">
                        <input type="text" :value="autodelete_personal_form" @input="changedInput('personal', $event)"
                            :size="personal_size"
                            class="text-center inline py-0 mt-0 px-0.5 border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-blue-500 font-bold focus:bg-blue-50 text-sm" />
                    </div>
                    <div class="flex mr-1">
                        <span v-if="autodelete_personal_form > 1">days</span>
                        <span v-else>day</span>
                    </div>
                    <div class="flex mr-1">
                        <jet-dropdown align="left" width="36" class="flex" style="margin-top:-1px">
                            <template #trigger>
                                <span class="inline-flex rounded-md">
                                    <button type="button"
                                        class="inline-flex items-center px-2 py-0 border border-transparent focus:outline-none"
                                        :class="tag_alert_personal ? 'text-red-500 hover:text-red-700' : personal_tag_name_exception == '' ? 'text-gray-500 hover:text-gray-700' : 'text-black hover:text-gray-700'"
                                        v-tippy="{ content: tag_alert_personal ? 'Warning: this tag does not exist anymore, no exception will apply' : null }">

                                        <span v-if="tag_alert_personal" class="">
                                            except <span
                                                class="px-1 py-0.5 text-xs border border-gray-200 bg-gray-100 rounded font-bold"
                                                :class="tag_alert_personal ? 'text-red-500' : 'text-blue-700'">{{
                                                    personal_tag_name_exception }}</span> tag
                                        </span>
                                        <span v-else-if="personal_tag_name_exception == ''" class="">
                                            with no tag exception
                                        </span>
                                        <span v-else class="">
                                            except <span class="px-2 py-1 rounded text-gray-700 text-xs"
                                                :style="'background-color:' + get_tag(personal_tag_slug_exception).color">{{
                                                    personal_tag_name_exception }}</span> tag
                                        </span>

                                        <svg v-if="tag_alert_personal" class="ml-2 -mr-0.5 h-4 w-4"
                                            xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <path
                                                d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z">
                                            </path>
                                            <line x1="12" y1="9" x2="12" y2="13"></line>
                                            <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                        </svg>
                                        <svg v-else class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </button>
                                </span>
                            </template>

                            <template #content>
                                <a href="#"
                                    class="px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                    :class="{ 'text-blue-500 font-bold': personal_tag_slug_exception == '' }"
                                    @click.prevent="changeException('personal', null)">
                                    <span class="flex flex-grow">No tag exception</span>
                                    <vue-feather v-if="personal_tag_slug_exception == ''" type="check"
                                        class="w-4 h-4 ml-2 self-center"></vue-feather>
                                </a>
                                <a href="#" v-for="tag in tags" :key="'tag_' + tag.id"
                                    class="px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                    :class="{ 'text-blue-500 font-bold': tag.slug == personal_tag_slug_exception }"
                                    @click.prevent="changeException('personal', tag)">
                                    <span class="flex flex-grow">{{ tag.name }}</span>
                                    <vue-feather v-if="tag.slug == personal_tag_slug_exception" type="check"
                                        class="w-4 h-4 ml-2 self-center"></vue-feather>
                                </a>
                            </template>
                        </jet-dropdown>
                    </div>
                </div>
                <div class="flex items-center">
                    <toggle :checked="is_enabled_personal && canChangeFeature" :disabled="!canChangeFeature"
                        @click.prevent.stop @update="togglePersonal"></toggle>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

import Toggle from '@/Components/UI/Toggle'
import UpgradePlan from '@/Components/UI/UpgradePlan'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import JetDropdown from '@/Jetstream/Dropdown'
import { UserIcon, UserGroupIcon, InboxArrowDownIcon } from "@heroicons/vue/20/solid";

export default {

    props: ['tags'],

    components: {
        Toggle, JetSectionBorder, JetDropdown, UpgradePlan,
        UserIcon, UserGroupIcon, InboxArrowDownIcon
    },

    created: function () {
        //console.log(this.tags)
        let metadata = JSON.parse(this.$page.props.user.current_team.metadata)
        if (metadata) {
            if (metadata.autodelete) {
                if (metadata.autodelete.incoming) {
                    if (metadata.autodelete.incoming.delay) {
                        this.autodelete_incoming = metadata.autodelete.incoming.delay
                        this.autodelete_incoming_form = this.autodelete_incoming
                    }
                    if (metadata.autodelete.incoming.exception) {
                        if (metadata.autodelete.incoming.exception.tag) {
                            this.incoming_tag_slug_exception = metadata.autodelete.incoming.exception.tag.slug
                            this.incoming_tag_name_exception = metadata.autodelete.incoming.exception.tag.name
                        }
                    }
                }
                if (metadata.autodelete.outgoing) {
                    if (metadata.autodelete.outgoing.delay) {
                        this.autodelete_outgoing = metadata.autodelete.outgoing.delay
                        this.autodelete_outgoing_form = this.autodelete_outgoing
                    }
                    if (metadata.autodelete.outgoing.exception) {
                        if (metadata.autodelete.outgoing.exception.tag) {
                            this.outgoing_tag_slug_exception = metadata.autodelete.outgoing.exception.tag.slug
                            this.outgoing_tag_name_exception = metadata.autodelete.outgoing.exception.tag.name
                        }
                    }
                }
                if (metadata.autodelete.personal) {
                    if (metadata.autodelete.personal.delay) {
                        this.autodelete_personal = metadata.autodelete.personal.delay
                        this.autodelete_personal_form = this.autodelete_personal
                    }
                    if (metadata.autodelete.personal.exception) {
                        if (metadata.autodelete.personal.exception.tag) {
                            this.personal_tag_slug_exception = metadata.autodelete.personal.exception.tag.slug
                            this.personal_tag_name_exception = metadata.autodelete.personal.exception.tag.name
                        }
                    }
                }
            }
        }
        if (this.incoming_tag_slug_exception != "") {
            this.tag_alert_incoming = this.get_tag(this.incoming_tag_slug_exception) == null;
        }
        if (this.outgoing_tag_slug_exception != "") {
            this.tag_alert_outgoing = this.get_tag(this.outgoing_tag_slug_exception) == null;
        }
        if (this.personal_tag_slug_exception != "") {
            this.tag_alert_personal = this.get_tag(this.personal_tag_slug_exception) == null;
        }

        // if (metadata.autodelete_incoming) {
        //     this.autodelete_incoming = metadata.autodelete_incoming
        //     this.autodelete_incoming_form = metadata.autodelete_incoming
        // }
        // if (metadata.autodelete_outgoing) {
        //     this.autodelete_outgoing = metadata.autodelete_outgoing
        //     this.autodelete_outgoing_form = metadata.autodelete_outgoing
        // }
    },

    data() {
        return {
            autodelete_incoming: 0,
            autodelete_outgoing: 0,
            autodelete_personal: 0,

            incoming_tag_slug_exception: "",
            outgoing_tag_slug_exception: "",
            personal_tag_slug_exception: "",
            incoming_tag_name_exception: "",
            outgoing_tag_name_exception: "",
            personal_tag_name_exception: "",

            tag_alert_incoming: false,
            tag_alert_outgoing: false,
            tag_alert_personal: false,

            autodelete_incoming_form: 0,
            autodelete_outgoing_form: 0,
            autodelete_personal_form: 0,

            timeout: Object,
            buffer: 600,
            lastTypeMoment: 0,
            defaultValue: 30,
            minValue: 1,
            maxValue: 3000,
            shot_max_alert: false,
            canChangeFeature: this.$page.props.isz || this.$page.props.plan_autodeletion_screenrecording
        }
    },

    mounted: function () {
    },

    methods: {
        showUpgradeModal: function () {
            this.EventBus.emit('showUpgrade', ['feature', 'autodelete'])
        },
        toggleInbound: function (checked) {
            if (this.autodelete_incoming > 0) {
                this.autodelete_incoming = 0
            } else {
                this.autodelete_incoming = this.defaultValue
                this.autodelete_incoming_form = this.defaultValue
            }
            this.updateSecurity("incoming")
        },
        toggleOutbound: function (checked) {
            if (this.autodelete_outgoing > 0) {
                this.autodelete_outgoing = 0
            } else {
                this.autodelete_outgoing = this.defaultValue
                this.autodelete_outgoing_form = this.defaultValue
            }
            this.updateSecurity("outgoing")
        },
        togglePersonal: function (checked) {
            if (this.autodelete_personal > 0) {
                this.autodelete_personal = 0
            } else {
                this.autodelete_personal = this.defaultValue
                this.autodelete_personal_form = this.defaultValue
            }
            this.updateSecurity("personal")
        },

        changedInput: function (way, event) {
            clearTimeout(this.timeout);
            const value = event.target.value.trim()
            if (value == "") {
                if (way == "incoming") {
                    this.autodelete_incoming_form = ""
                } else if (way == "outgoing") {
                    this.autodelete_outgoing_form = ""
                } else if (way == "personal") {
                    this.autodelete_personal_form = ""
                }
                this.$forceUpdate()
                return
            }
            let pattern = /^\d+$/;
            if (!pattern.test(value)) { // not a number, keep previous value
                if (way == "incoming") {
                    this.autodelete_incoming_form = this.autodelete_incoming
                } else if (way == "outgoing") {
                    this.autodelete_outgoing_form = this.autodelete_outgoing
                } else if (way == "personal") {
                    this.autodelete_personal_form = this.autodelete_personal
                }
                this.$forceUpdate()
                return
            }

            let value_without_leading_zeros = value.replace(/^0+/, '')
            if (value_without_leading_zeros == "") {
                if (way == "incoming") {
                    this.autodelete_incoming_form = ""
                } else if (way == "outgoing") {
                    this.autodelete_outgoing_form = ""
                } else if (way == "personal") {
                    this.autodelete_personal_form = ""
                }
                this.$forceUpdate()
                return
            }

            if (value_without_leading_zeros.toString().length > this.maxValue.toString().length ||
                value_without_leading_zeros > (this.maxValue + 1)) {
                if (way == "incoming") {
                    this.autodelete_incoming_form = this.autodelete_incoming
                } else if (way == "outgoing") {
                    this.autodelete_outgoing_form = this.autodelete_outgoing
                } else if (way == "personal") {
                    this.autodelete_personal_form = this.autodelete_personal
                }
                this.$forceUpdate()
                if (!this.shot_max_alert) {
                    this.shot_max_alert = true
                    let options = {
                        type: "info",
                        timeout: 5000,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Enter a value between 1 and " + this.maxValue + " days", options)
                }
                return
            } else {
                if (way == "incoming") {
                    this.autodelete_incoming = value_without_leading_zeros
                    this.autodelete_incoming_form = value_without_leading_zeros
                } else if (way == "outgoing") {
                    this.autodelete_outgoing = value_without_leading_zeros
                    this.autodelete_outgoing_form = value_without_leading_zeros
                } else if (way == "personal") {
                    this.autodelete_personal = value_without_leading_zeros
                    this.autodelete_personal_form = value_without_leading_zeros
                }
                this.timeout = setTimeout(function () { this.updateSecurity(way) }.bind(this), this.buffer);
            }
        },
        updateSecurity: function (type) {
            var url = this.$page.props.api_url + '/v1/team/set_meta';
            var meta_name = "autodelete"

            var meta_value = {}
            if (this.autodelete_incoming > 0) {
                meta_value.incoming = {
                    delay: this.autodelete_incoming
                }
                if (this.incoming_tag_name_exception) {
                    meta_value.incoming.exception = {
                        tag: {
                            slug: this.incoming_tag_slug_exception,
                            name: this.incoming_tag_name_exception,
                        }
                    }
                }
            }
            if (this.autodelete_outgoing > 0) {
                meta_value.outgoing = {
                    delay: this.autodelete_outgoing
                }
                if (this.outgoing_tag_name_exception) {
                    meta_value.outgoing.exception = {
                        tag: {
                            slug: this.outgoing_tag_slug_exception,
                            name: this.outgoing_tag_name_exception,
                        }
                    }
                }
            }
            if (this.autodelete_personal > 0) {
                meta_value.personal = {
                    delay: this.autodelete_personal
                }
                if (this.personal_tag_name_exception) {
                    meta_value.personal.exception = {
                        tag: {
                            slug: this.personal_tag_slug_exception,
                            name: this.personal_tag_name_exception,
                        }
                    }
                }
            }

            if (Object.keys(meta_value).length === 0) {
                url = this.$page.props.api_url + '/v1/team/delete_meta';
            }

            // var meta_name = "autodelete_incoming";
            // var meta_value = this.autodelete_incoming;
            // if (type == "outgoing") {
            //     meta_name = "autodelete_outgoing";
            //     meta_value = this.autodelete_outgoing;
            // }

            var params = {
                meta: meta_name,
                value: meta_value
            };

            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                })
                .catch(e => {
                    console.error(e);
                });
        },
        changeException: function (way, tag) {
            if (way == "incoming") {
                this.tag_alert_incoming = false
            } else if (way == "outgoing") {
                this.tag_alert_outgoing = false
            } else if (way == "personal") {
                this.tag_alert_personal = false
            }
            const previous_incoming_slug = this.incoming_tag_slug_exception
            const previous_outgoing_slug = this.outgoing_tag_slug_exception
            const previous_personal_slug = this.personal_tag_slug_exception
            if (tag == null) {
                if (way == 'incoming') {
                    this.incoming_tag_slug_exception = ""
                    this.incoming_tag_name_exception = ""
                } else if (way == 'outgoing') {
                    this.outgoing_tag_slug_exception = ""
                    this.outgoing_tag_name_exception = ""
                } else if (way == 'personal') {
                    this.personal_tag_slug_exception = ""
                    this.personal_tag_name_exception = ""
                }
            } else {
                if (way == 'incoming') {
                    this.incoming_tag_slug_exception = tag.slug
                    this.incoming_tag_name_exception = tag.name
                } else if (way == 'outgoing') {
                    this.outgoing_tag_slug_exception = tag.slug
                    this.outgoing_tag_name_exception = tag.name
                } else if (way == 'personal') {
                    this.personal_tag_slug_exception = tag.slug
                    this.personal_tag_name_exception = tag.name
                }
            }
            if (previous_incoming_slug != this.incoming_tag_slug_exception || previous_outgoing_slug != this.outgoing_tag_slug_exception || previous_personal_slug != this.personal_tag_slug_exception) {
                this.updateSecurity()
            }
        },
        get_tag: function (slug) {
            for (var i = 0; i < this.tags.length; i++) {
                let tag = this.tags[i]
                if (tag.slug == slug) {
                    return tag
                }
            }
            return null
        },
    },

    computed: {
        is_enabled_inbound: function () {
            return this.autodelete_incoming > 0
        },
        is_enabled_outbound: function () {
            return this.autodelete_outgoing > 0
        },
        is_enabled_personal: function () {
            return this.autodelete_personal > 0
        },
        incoming_size() {
            return Math.round(this.autodelete_incoming.toString().length * 1)
        },
        outgoing_size() {
            return Math.round(this.autodelete_outgoing.toString().length * 1)
        },
        personal_size() {
            return Math.round(this.autodelete_personal.toString().length * 1)
        },
        /*incoming_tag_name_exception: function() {
            if (this.incoming_tag_slug_exception != "") {
                for(var i=0; i<this.tags.length; i++) {
                    let tag = this.tags[i]
                    if (tag.slug == this.incoming_tag_slug_exception) {
                        return tag.name
                    }
                }
            }
            return "";
        },
        outgoing_tag_name_exception: function() {
            if (this.outgoing_tag_slug_exception != "") {
                for(var i=0; i<this.tags.length; i++) {
                    let tag = this.tags[i]
                    if (tag.slug == this.outgoing_tag_slug_exception) {
                        return tag.name
                    }
                }
            }
            return "";
        }*/
    }
}


</script>

<style scoped></style>
